import { GUID } from "../../helpers/guid.helper";

export class NoticiaMultimedia{
    Id: string;
    Url: string;
    Titulo:  string;
    EsPortada: boolean
    constructor() {
        this.Id = GUID.newGuid();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/multimedia-noticia/noticia-multimedia.ts